import background from "./background.png";
import logo from "./logo.png";

export default {
  background,
  logo,
};
